import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, QueryList, ViewChildren } from '@angular/core';
import { PlotlyService } from 'angular-plotly.js';
import { PlotlyHTMLElement } from 'plotly.js';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'comparison-tab',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss']
})
export class ComparisonComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() charts: Array<any>;
  @Input() runs: Number;
  @Input() resizeGraphSubject: Subject<boolean>;
  @Input() versionNo: any;

  @ViewChildren('radarChart') containerDivs: QueryList<ElementRef>;

  radarPlot = {
    data: [
      {
        r: [39, 28, 8, 7, 28, 39],
        theta: ['A', 'B', 'C', 'D', 'E', 'A'],
        type: 'scatterpolar',
        fill: 'toself',
        name: 'Group A'
      },
      {
        r: [5, 14, 30, 17, 25],
        theta: ['A', 'B', 'C', 'D', 'F'],
        type: 'scatterpolar',
        fill: 'toself',
        name: 'Group B'
      }
    ],
    layout: {
      autosize: true
    }
  };

  constructor(private plotlyRef: PlotlyService) { }

  ngOnInit(): void {
    // for window resize handling (graph responsiveness)
    fromEvent(window, 'resize').pipe(
      debounceTime(250))
      .subscribe(() => this.refreshAll());

    this.resizeGraphSubject
      .pipe(debounceTime(250))
      .subscribe(() => this.refreshAll());

  }

  ngAfterViewInit() {
    this.plotGraphs();
  }

  ngOnChanges() {
    this.plotGraphs();
  }

  variablesSelectionChanged() {
    this.plotGraphs();
  }

  plotGraphs() {
    setTimeout(() => {
      this.containerDivs && this.containerDivs.forEach((e, index) => {
        const spiderChartData = [];
        for (let i = 0; i < this.charts[index].spiderPlot[0].length; i++) {
          let clusterName = '';
          this.charts[index].clusteringLabels.forEach(element => {
            (element.label_id == i+1) ? clusterName = element.label_name : null;
          });
          const r = [];
          this.charts[index].spiderVariables.forEach((e) => {
            if (this.charts[index].spiderPlot[1].indexOf(e) > -1) {
              r.push(this.charts[index].spiderPlot[0][i][this.charts[index].spiderPlot[1].indexOf(e)]);
            }
          });
          spiderChartData.push({
            r: r,
            theta: this.charts[index].spiderVariables,
            type: 'scatterpolar',
            fill: 'toself',
            name: clusterName
          });
        }
        this.charts[index].dataPlot = spiderChartData;
      });
      this.appendGraphs();
    }, 100);
  }

  appendGraphs() {
    setTimeout(() => {
      this.containerDivs && this.containerDivs.forEach((e, index) => {
        this.plotGraph(this.charts[index].dataPlot, this.radarPlot.layout, e.nativeElement);
      });
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);
    }, 20);
  }

  plotGraph(data, layout, htmlDivElement: HTMLDivElement) {
    this.plotlyRef.newPlot(
      htmlDivElement,
      data,
      layout
    ).then((res: PlotlyHTMLElement) => {
    });
  }

  refreshAll() {
    this.containerDivs && this.containerDivs.forEach((e, index) => {
      this.refreshGraph(this.charts[index].dataPlot, this.radarPlot.layout, e.nativeElement);
    });
  }

  refreshGraph(data, layout, htmlDivElement) {
    this.plotlyRef.update(htmlDivElement, data, layout);
  }

}
